import { ColumnType, getStatusColor } from '@Common/Table';
import { GeneratedHistory } from '@Models/types';
import { FeatDescrip, IssueDescrip } from '@Models/types';
import { getFields } from '@Utils/helpers';

const parseDate = (timestamp: number) => {
  const date = new Date(timestamp);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  const formattedDate = `${month.toString().padStart(2, '0')}/${day
    .toString()
    .padStart(2, '0')}/${year}`;
  return formattedDate;
};

const parseRequirements = (req: string) => {
  return JSON.parse(req) as FeatDescrip[] | IssueDescrip[];
};

const GeneratedHistoryColumns: ColumnType<GeneratedHistory>[] = [
  {
    header: 'Reference',
    accessor: 'requirements',
    Cell: (value: string) => {
      const requirements = parseRequirements(value);

      return (
        <div className="grid grid-cols-1 gap-1">
          {requirements.map((req, index) => (
            <div key={index} className="flex items-start">
              <span className="whitespace-nowrap text-xs font-bold">
                {getFields(req).id}
              </span>
            </div>
          ))}
        </div>
      );
    },
  },
  {
    header: 'Requirements',
    accessor: 'requirements',
    Cell: (value: string) => {
      const requirements = parseRequirements(value);

      return (
        <div className="grid grid-cols-1 gap-1">
          {requirements.map((req, index) => (
            <div key={index} className="flex items-start">
              <span
                className="max-w-[500px] overflow-hidden text-ellipsis whitespace-nowrap text-xs"
                title={getFields(req).title}
              >
                {getFields(req).title}
              </span>
            </div>
          ))}
        </div>
      );
    },
  },
  {
    header: 'Date',
    accessor: 'timestamp',
    Cell: (value: number) => (
      <span className="text-xs">{parseDate(value)}</span>
    ),
  },
  {
    header: 'Status',
    accessor: 'completion_status',
    Cell: (value: string) => (
      <span className={`${getStatusColor(value)} text-xs font-bold uppercase`}>
        {value}
      </span>
    ),
  },
];

export { GeneratedHistoryColumns, parseDate, parseRequirements };
